import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-41c6b3ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "upload-container"
}
const _hoisted_2 = { class: "progress-row" }
const _hoisted_3 = {
  key: 0,
  class: "icon-row"
}
const _hoisted_4 = { class: "nowrap-txt" }
const _hoisted_5 = {
  key: 1,
  class: "icon-row"
}
const _hoisted_6 = { class: "progress-cntr cm-ui-ml20" }
const _hoisted_7 = {
  key: 1,
  class: "upload-container"
}
const _hoisted_8 = { class: "icon-row" }


export default /*#__PURE__*/_defineComponent({
  __name: 'upload-dialog',
  props: {
  percent: {
    type: Number,
    default: 0
  },
  fileName: {
    type: String,
    default: ''
  },
  uploading: {
    type: Number,
    default: 0
  },
  errorMsg: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const LOADING_STATUS = {
  RUNNING: 1,
  // eslint-disable-next-line no-magic-numbers
  TIMEOUT: 2,
  // eslint-disable-next-line no-magic-numbers
  SUCCESS: 3,
  // eslint-disable-next-line no-magic-numbers
  FAIL: 4
}




return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return ([LOADING_STATUS.RUNNING, LOADING_STATUS.SUCCESS].includes(__props.uploading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.uploading === LOADING_STATUS.RUNNING)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_CmSvgIcon, {
                  class: "upload-icon cm-ui-mr10",
                  name: "_images/upload-big",
                  monochrome: "",
                  size: 20
                }),
                _createTextVNode(" 正在上传 - "),
                _createElementVNode("span", _hoisted_4, _toDisplayString(__props.fileName), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.uploading === LOADING_STATUS.SUCCESS)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_CmSvgIcon, {
                  class: "success-icon cm-ui-mr10",
                  name: "_images/success",
                  monochrome: "",
                  size: 20
                }),
                _createTextVNode(" 上传成功，正在更新中 ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_progress, {
              percentage: Number(__props.percent.toFixed(1)),
              indeterminate: __props.uploading === LOADING_STATUS.SUCCESS,
              "stroke-width": 16,
              class: "progress-color"
            }, null, 8, ["percentage", "indeterminate"])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_CmSvgIcon, {
            class: "error-icon cm-ui-mr10",
            name: "_images/error",
            monochrome: "",
            size: 30
          }),
          _createElementVNode("span", null, _toDisplayString(__props.errorMsg), 1)
        ])
      ]))
}
}

})